var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavesDefi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0055FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 39.7628H21.4503M19.6666 35.1188H21.4503M19.6666 19.6668V44.3335H44.3333M19.6658 21.4892H21.4494M19.6658 26.0425H21.4494M19.6658 30.5595H21.4494",
    stroke: "#0055FF",
    strokeWidth: 2,
    strokeMiterlimit: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4737 37.4493C27.4737 37.9258 27.2843 38.3828 26.9474 38.7198C26.6104 39.0568 26.1534 39.2461 25.6769 39.2461C25.2003 39.2461 24.7433 39.0568 24.4063 38.7199C24.0693 38.3829 23.8799 37.9259 23.8799 37.4493C23.8799 36.9727 24.0692 36.5156 24.4062 36.1786C24.7432 35.8416 25.2003 35.6523 25.6769 35.6523C26.1534 35.6523 26.6105 35.8417 26.9474 36.1787C27.2844 36.5157 27.4737 36.9727 27.4737 37.4493ZM31.8434 28.7265C31.8434 28.9625 31.7969 29.1962 31.7066 29.4142C31.6163 29.6322 31.4839 29.8303 31.317 29.9972C31.1501 30.1641 30.952 30.2964 30.7339 30.3867C30.5159 30.477 30.2822 30.5235 30.0462 30.5235C29.5696 30.5235 29.1125 30.3341 28.7755 29.9971C28.4385 29.6601 28.2492 29.2031 28.2492 28.7265C28.2492 28.2499 28.4385 27.7928 28.7755 27.4558C29.1125 27.1188 29.5696 26.9295 30.0462 26.9295C30.5228 26.9295 30.9798 27.1189 31.3168 27.4559C31.6537 27.7929 31.843 28.2499 31.843 28.7265H31.8434ZM39.106 34.7925C39.106 35.269 38.9167 35.7261 38.5797 36.063C38.2427 36.4 37.7856 36.5893 37.309 36.5893C36.8325 36.5893 36.3755 36.3999 36.0385 36.063C35.7016 35.726 35.5123 35.269 35.5122 34.7925C35.5122 34.3159 35.7015 33.8589 36.0385 33.5219C36.3755 33.1849 36.8325 32.9955 37.309 32.9955C37.7856 32.9955 38.2427 33.1848 38.5797 33.5218C38.9167 33.8588 39.106 34.3159 39.106 34.7925ZM42.7067 22.5598C42.7067 23.0364 42.5174 23.4935 42.1804 23.8305C41.8434 24.1675 41.3863 24.3568 40.9097 24.3568C40.4331 24.3568 39.976 24.1675 39.639 23.8305C39.302 23.4935 39.1127 23.0364 39.1127 22.5598C39.1128 22.0832 39.3021 21.6262 39.6391 21.2892C39.9761 20.9523 40.4331 20.763 40.9097 20.763C41.3863 20.763 41.8433 20.9523 42.1802 21.2893C42.5172 21.6263 42.7065 22.0833 42.7065 22.5598H42.7067Z",
    stroke: "#0055FF",
    strokeWidth: 2,
    strokeMiterlimit: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.73 35.6996L29.0828 30.4726M31.5961 30.0686L35.6516 33.5893M37.9296 32.9114L40.518 24.1793",
    stroke: "#0055FF",
    strokeWidth: 1.33333,
    strokeMiterlimit: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesDefi);
export default __webpack_public_path__ + "static/media/waves-defi.ce205a3f1862da0cf396117b072f82a4.svg";
export { ForwardRef as ReactComponent };